/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ScheduledEftWithdrawResponse,
  ScheduledEftWithdraw: (params: vp.ScheduledEftWithdrawRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostScheduledEftWithdraw: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldScheduledEftWithdraw, setShouldScheduledEftWithdraw] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.ScheduledEftWithdrawRequest>({
    Amount: 0,
    Frequency: '',
    AccountNumber: '',
    FinancialInstitutionNumber: '',
    BranchTransitNumber: '',
    NameOfFrequency: '',
    ScheduleStartDate: '',
    ScheduleEndDate: '',
    EndingAfterPayments: '',
    Description: '',
    PortalUser: '',
    SemiMonthlyFrequencyType: '',
    FirstName: '',
    LastName: '',
    CompanyName: '',
    PhoneNumber: '',
    Address1: '',
    City: '',
    Province: '',
    Country: '',
    PostalCode: '',
    EmailAddress: '',
    DOB: '',
    Token: '',
    IPAddress: '',
    ClientReferenceNumber: '',
    Notes: '',
    FlinksAccountID: '',
    FlinksLoginID: '',
    PlaidAccountID: '',
    PlaidPublicToken: '',
    PlaidAccessToken: '',
    PlaidProcessorToken: '',
    InveriteRequestGUID: '',
    DelayBankingInfo: false,
    KYCPerformed: false,
    IdempotencyKey: '',
  });
  const [response, setResponse] = useState<vp.ScheduledEftWithdrawResponse>({
    Success: false,
    ErrorMessage: '',
    Amount: 0,
    ScheduledTransactionID: '',
    Frequency: '',
    Description: '',
    ScheduleStartDate: '',
    Status: '',
  });

  useEffect(() => {
    if (!shouldScheduledEftWithdraw) return () => {};

    const PostScheduledEftWithdraw = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.postScheduledEftWithdraw(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldScheduledEftWithdraw) void PostScheduledEftWithdraw();
    setShouldScheduledEftWithdraw(false);
    return () => {
      source.cancel();
    };
  }, [shouldScheduledEftWithdraw]);

  return [
    response,
    (_params: vp.ScheduledEftWithdrawRequest) => {
      setParams(_params);
      setShouldScheduledEftWithdraw(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Amount: 0,
        ScheduledTransactionID: '',
        Frequency: '',
        Description: '',
        ScheduleStartDate: '',
        Status: '',
      });
      setShouldScheduledEftWithdraw(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostScheduledEftWithdraw);